export const countryPrefixSupported = [
  'pe',
  'ar',
  'mx',
  'co',
  'es',
  'cl',
  'bo',
  'cr',
  'ec',
  // 'br',
];
